<template>
  <div>
    <div class="banner">
      <img class="smallImg" src="./../assets/img/img_bg3_news.png">
      <img class="bigImg" src="http://www.lvshouhotel.com/lvshouhotel/img_bg_news.png">
    </div>
    <div class="hotel-dynamic-content box_s clearfix">
      <ul class="box_s clearfix">
        <li class="hotel-dynamic-content-item box_s clearfix" v-for="(item,index) in hotelDynamicData" :key="index" v-show="index >= minIndex && index < maxIndex" >
          <div class="artical-covermap fl">
            <img data-v-fae5bece="" :src="item.imgUrl">
          </div>
          <div class="artical-body fl">
            <h4 class="artical-title">{{item.title}}</h4>
            <p class="artical-desc">{{item.desc}}</p>
            <p class="artical-time" @click="goArticalFn(index)">查看详情</p>
          </div>
        </li>
      </ul>
      <!-- 分页 -->
      <div class="fenye fr ta_c" v-if="hotelDynamicData.length > 5">
        <span class="fenye-item" @click="changeData(index)" :class="pagesize == index ? 'fenye-active':''" v-for="(item,index) in hotelDynamicData.length" v-show="index < Math.ceil(hotelDynamicData.length/4)" :key="index">{{index*1 +1}}</span>
      </div>
    </div>
    <!-- <ArticalOne v-if="index == 0 && isShowArtical"></ArticalOne>
    <ArticalTow v-if="index == 1 && isShowArtical"></ArticalTow> -->
  </div>
</template>
<script>
import hotelDynamic from "@/assets/json/hotelDynamic"
import ArticalOne from "@/components/hotelDynamic/articalOne";
import ArticalTow from "@/components/hotelDynamic/articalTow";

export default {
  name:'hotelDynamic',
  data(){
    return{
      index:0,
      pagesize:0, //页码
      minIndex:0,//当前页面显示第一条数据的index
      maxIndex:4,//当前页面显示最后一条数据的index
      hotelDynamicData: hotelDynamic,
      isShowArtical:false
    }
  },
  methods:{
    changeData(val){
      this.pagesize =val;
      this.minIndex = 4 * (val*1);
      this.maxIndex = 4 * (val*1+1);
    },
    goArticalFn(val){
      this.index = val;
      this.isShowArtical = true;
       this.$router.push({
        path: "/hotelDynamic/artical",
        query: {
          id: val
        }
      });
      
    }
  },
  components:{
    ArticalOne,
    ArticalTow
  }
}
</script>
<style lang="less" scoped>
.hotel-dynamic-content{
  width:1133px;
  margin: 157px auto 240px;
  ul{
    width:100%;
    border-bottom: 3px solid rgba(216,216,216,.24);
    .hotel-dynamic-content-item{
      cursor: pointer;
      margin-bottom: 80px;
      .artical-covermap{
        width: 350px;
        height: 236px;
        margin-right:48px;
        img{
          width: 100%;
        }
      }
      .artical-body{
        width: 680px;
        padding-top: 32px;
        .artical-title{
          font-size: 20px;
          color: #333333;
        }
        .artical-desc{
          padding: 18px 0 32px;
          font-size: 16px;
          line-height: 32px;
          color: #666666;
        }
        .artical-time{
          display: inline-block;
          width:60px;
          color: #B99740;
          line-height: 16px;
          font-size: 14px;
          padding-bottom:1px;
          border-bottom: 1px solid #B99740;
          &:hover{
            color: #876a20;
            border-bottom: 1px solid #876a20;
          }
        }
      }
    }
  }
}
</style>
